<template>
  <div>
    <el-dialog title="常用语" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px">
      <div class="input-box">
        <el-input v-model="inputVal" placeholder="搜索" prefix-icon="el-icon-search"></el-input>
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </div>
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="cont-box">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="平台推荐" name="1"></el-tab-pane>
            <el-tab-pane label="自定义" name="2"></el-tab-pane>
          </el-tabs>
          <el-button type="primary" size="small" v-if="activeName === '2'" @click="handleCreate">新增常用语言</el-button>
          <div class="list-box" v-if="activeName === '1'">
            <div class="list" v-for="(item,index) in phrasesOptions" :key="index">
              <span @click="handleActive(item)" :class="{'active': item.active}">{{item.title}}</span>

            </div>
          </div>
          <div class="list-box" v-if="activeName === '2'">
            <div class="list" v-for="(item,index) in phrasesMeOptions" :key="index">
              <span @click="handleActive(item)" :class="{'active': item.active}">{{item.title}}</span>
              <template v-if="activeName === '2'">
                <i class="el-icon-edit" @click="handleUpdate(item)"></i>
                <i class="el-icon-delete" @click="handleDeleteSingle(item,index)"></i>
              </template>
            </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="doCreate()">发送</el-button>
        </div>
      </div>
    </el-dialog>
    <phrases-add ref="phrasesAdd" isMessage="1" @created="getPhrasesMeList()" />
  </div>
</template>

<script>
import custServiceSpeechcraftApi from '@/api/customer/custServiceSpeechcraft'
import phrasesAdd from '../../phrases/add.vue'
export default {
  components: { phrasesAdd },
  data() {
    return {
      form: { advertisingTitle: null },
      formVisible: false,
      formAddVisible: false,
      activeName: '1',
      phrasesOptions: [],
      phrasesMeOptions: [],
      inputVal: '',
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
  },
  watch: {
    inputVal(newVal) {
      if (newVal === '') {
        if (this.activeName === '1') { this.getPhrasesList() }
        else { this.getPhrasesMeList() }
      }
    }
  },
  methods: {
    getPhrasesList() {
      custServiceSpeechcraftApi.fetchForList({ isGetCustServiceStaffId: true, title: this.inputVal, isEnable: true }).then(({ data }) => {
        let { list } = data;
        this.phrasesOptions = list;
        this.$forceUpdate();
      })
    },
    getPhrasesMeList() {
      custServiceSpeechcraftApi.fetchForMeList({ title: this.inputVal, isEnable: true }).then(({ data }) => {
        let { list } = data;
        this.phrasesMeOptions = list;
        this.$forceUpdate();
      })
    },
    handleSearch() {
      if (this.activeName === '1') { this.getPhrasesList() }
      else { this.getPhrasesMeList() }
    },
    handleActive(item) {
      this.rowItem = item
      if (this.activeName === '1') {
        this.phrasesOptions.forEach(itt => {
          itt.active = itt.id === item.id ? true : false
        })
      } else {
        this.phrasesMeOptions.forEach(itt => {
          itt.active = itt.id === item.id ? true : false
        })
      }
      this.$forceUpdate()
    },
    handleClick() {
      if (this.activeName === '1') {
        if (!this.phrasesOptions.length) this.getPhrasesList()
      } else {
        if (!this.phrasesMeOptions.length) this.getPhrasesMeList()
      }
    },
    handleShow() {
      this.formVisible = true
      this.getPhrasesList()
    },
    doCreate() {
      this.$emit('created', this.rowItem, 16)
      this.formVisible = false
    },
    handleCreate(row) {
      this.$refs.phrasesAdd.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.phrasesAdd.handleUpdate(row)
    },
    handleDeleteSingle(row, index) {
      return this.$common.confirm('是否确认删除').then(() => custServiceSpeechcraftApi.deleteByIdMe(row.id)).then(() => {
        this.phrasesMeOptions.splice(index, 1)
      })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.cont-box {
  padding: 0 20px;
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
.ipt-box:last-child {
  margin-bottom: 0;
}

.list-box {
  margin-top: 10px;
  .list {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    span {
      padding: 7px 20px;
      background: #5dbde71a;
      border-radius: 30px;
      margin-right: 13px;
      cursor: pointer;
      &.active {
        background: #1296db;
        color: #fff;
      }
    }
    i {
      font-size: 20px;
      cursor: pointer;
      &.el-icon-edit {
        color: #1296db;
        margin-right: 11px;
      }
      &.el-icon-delete {
        color: #e73f3f;
      }
    }
  }
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>
